import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {FormGroup, AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { SectorCategoriesComponent } from "../../sector-categories.component";

import { BaToastNotificationService } from '../../../../../../theme/services/baToastNotification'
import { UserAccountApi, SectorCategoryApi, SectorTypeApi, SectorApi } from '../../../../../../theme/services/sdk';

@Component({
  selector: 'sector-category-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  providers:[UserAccountApi,SectorCategoryApi,SectorTypeApi,SectorApi,BaToastNotificationService]
})
export class SectorCategoryForm{

  public form:FormGroup;
  public name:AbstractControl;
  public sector_id:AbstractControl;
  public sector_type_id:AbstractControl;
  public submitted:boolean = false;

  sector_list:Object;
  sector_type_list: Object= [];
  sector_category:Object;

  constructor(fb:FormBuilder, protected user:UserAccountApi, protected sectorCategory:SectorCategoryApi, protected sectorType:SectorTypeApi, protected sector:SectorApi, private route: ActivatedRoute, private router: Router, private toast:BaToastNotificationService, private data: SectorCategoriesComponent) {
    this.form = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'sector_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      'sector_type_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])]
    });

    this.name = this.form.controls['name'];
    this.sector_id = this.form.controls['sector_id'];
    this.sector_type_id = this.form.controls['sector_type_id'];
    this.user.isAuthenticated()?false:this.router.navigate(['login']);
  }

  ngOnInit() {

    this.sector.find().subscribe((res)=>{
      this.sector_list = res;
    })
    this.data.sector_category.subscribe(data=>{
      this.sector_category=data;
      this.populateSectorTypes(data['sector_id']);
    });
  }

  populateSectorTypes(sector) {
    if(this.sector_id['value']){
      this.sectorType.find({where:{sector_id:sector}}).subscribe((res)=>{
        this.sector_type_list = res;
      })
    }
  }

  isEmpty(list) {
    return (list && list.length > 0)
  }

  public onSubmit(values:Object):void {
    this.submitted = true;
    if (this.form.valid) {
      let self = this;
      let sc;

      if(this.sector_category['id']){
        sc = this.sectorCategory.upsert({
          id: this.sector_category['id'],
          name: self.name['value'],
          sector_id: self.sector_id['value'],
          sector_type_id: self.sector_type_id['value'],
        })
      }else{
        sc = this.sectorCategory.create({
          name: self.name['value'],
          sector_id: self.sector_id['value'],
          sector_type_id: self.sector_type_id['value'],
        })
      }


      sc.subscribe(res => {
        let msg: string;
        this.data.refresh();
        this.form.reset();
        if(this.sector_category['id']){
          this.data.cancelSelected();
          msg = 'Record updated';
        }else{
          msg = 'New sector category added';
        }
        this.toast.success({
          heading: 'Success',
          text: msg,
          stack: 3
        });
      }, err=>{
        this.toast.error({
          heading: err.name,
          text: err.message,
          stack: 3
        });
        console.log(err);
      });
    }
  }

  cancelSelected(){
    this.data.cancelSelected();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/sector-categories/components/form/form.component.ts